import React from 'react'
import { StyledTextArea } from './styles'

const TextArea = ({ width, ...rest }) => {
  return <StyledTextArea width={width} {...rest} />
}

export default TextArea
